import { useEffect, useRef, useState } from 'react';
import { SvgIcon } from '../../../../common/components/SvgIcon';

interface CopyButtonProps {
  text: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  onCopy?: (error?: Error) => void;
}

type CopyStatus = 'idle' | 'copied' | 'error';

export const CopyButton = ({ size = 'md', onCopy, text }: CopyButtonProps) => {
  const [status, setStatus] = useState<CopyStatus>('idle');
  const timeoutRef = useRef<NodeJS.Timeout>();

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(text);
      onCopy?.();
      setStatus('copied');
    } catch (error) {
      onCopy?.(error as Error);
      setStatus('error');
    }
    if (timeoutRef?.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => setStatus('idle'), 1000);
  };

  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }, []);

  return (
    <button type="button" onClick={copyToClipboard} className={`btn btn-icon btn-flat-secondary btn-${size}`}>
      {status === 'error' && <SvgIcon type="close" className="text-danger" />}
      {status === 'copied' && <SvgIcon type="check" className="text-success" />}
      {status === 'idle' && <SvgIcon type="content_copy" />}
    </button>
  );
};
